import { useTranslation } from "react-i18next";
import { useNavigate, NavLink } from "react-router-dom";
import CommonReactGUIElementsFactory from "../../../../../../commonreact/main/factorys/guielements/CommonReactGUIElementsFactory";
import { ELng } from "../../../../../../language/main/LanguageKeysEnums";
import AppLanguageService from "../../../../logic/AppLanguageService";
import { ERoute } from "../../../routes/RoutesEnums";
import { IDeviceStateControllerReturn } from "../../../../../../commonreact/main/services/devicestate/DeviceStateController";
import AppCSSService from "../../../services/AppCSSService";
import AppSVGStore from "../../../services/AppSVGStore";
import { IPublicNavbarControllerReturn } from "./PublicNavbarController";
import { images } from "../../../../../../Media";
import { IEditBaseControllerReturn } from "../../../controllers/EditBaseController";

interface IProps {
  ebc: IEditBaseControllerReturn;
  dsc: IDeviceStateControllerReturn;
  pnc: IPublicNavbarControllerReturn;
}

const PublicNavbar: React.FC<IProps> = (props): JSX.Element => {

  const { t } = useTranslation();
  const ef = CommonReactGUIElementsFactory.getFactory({ keyStart: "" });

  const navClasses = `hover:text-bluec ${props.pnc.textProps} mt-2 mb-2 text-center`;
  const navIsActiveClass = "text-bluec";
  const navigate = useNavigate();

  //#region smallGUI
  const getSmallGUI = (): JSX.Element => {
    return (
      <div
        className={`w-full flex flex-col p-2 items-center ${AppCSSService.textDefault}`}
      >
        <div className={`${props.dsc.small?"w-full":" w-8/12"} flex flex-row pt-1.5 m-auto">`}>
            {getHome()}
          <div className={`flex flex-row-reverse items-center  w-full gap-3`} >
            {getMenu()}
            {getLng()}
          </div>
        </div>
        <div className={`mt-0 flex flex-row ${(props.pnc.menuIsOpen) ? ("block") : ("hidden")}`}>
          {getNavsSmallGUI()}
        </div>
      </div>
    );
  }

  const getMenu = () => {
    return <button
      onClick={() => props.pnc.setIsOpen(!props.pnc.menuIsOpen)}
      className={`${(!props.pnc.isSmallGUI) ? "hidden" : "visible"}  p-2`}
    >
      {!props.pnc.menuIsOpen ? (AppSVGStore.getMenu({ size: 50 })) : (AppSVGStore.getClose({ size: 50 }))}
    </button>
  }


  const getNavsSmallGUI = () => {
    return <nav className={`${AppCSSService.textHeader} w-full`} >
      <div className={`w-full flex gap-3 flex-col`} >
        <NavLink to={ERoute.Home.valueOf()} onClick={() => props.pnc.setIsOpen(false)} className={({ isActive }) => `${navClasses} ${isActive ? navIsActiveClass : ''}`} > {t(ELng.nav_woh_app.valueOf())} </NavLink>
        <NavLink to={ERoute.AboutUs.valueOf()} onClick={() => props.pnc.setIsOpen(false)} className={({ isActive }) => `${navClasses} ${isActive ? navIsActiveClass : ''}`} > {t(ELng.nav_about_us.valueOf())} </NavLink>
        <NavLink to={ERoute.PrivacyPolicy.valueOf()} onClick={() => props.pnc.setIsOpen(false)} className={({ isActive }) => `${navClasses} ${isActive ? navIsActiveClass : ''}`} > {t(ELng.nav_privacy_policy.valueOf())} </NavLink>
        <NavLink to={ERoute.Service.valueOf()} onClick={() => props.pnc.setIsOpen(false)} className={({ isActive }) => `${navClasses} ${isActive ? navIsActiveClass : ''}`} > {t(ELng.nav_service.valueOf())} </NavLink>
        <NavLink to={ERoute.Website.valueOf()} onClick={() => props.pnc.setIsOpen(false)} className={({ isActive }) => `${navClasses} ${isActive ? navIsActiveClass : ''}`} > {t(ELng.nav_woh_site.valueOf())} </NavLink>
      </div>
    </nav>
  }
  //#endregion


  //#region defaultGUI
  const getDefaultGUI = (): JSX.Element => {
    return (
      <div className={`w-full flex flex-row p-2 ${AppCSSService.textSmall}`}>
        {/* <div className='w-2/12'></div> */}
        <div className="w-8/12 flex flex-row pt-1.5 m-auto">
          <div className=''>
            {getHome()}
          </div>
          <div className='w-10/12'>
            {getNavs()}
          </div>
          <div className={`flex flex-row items-center justify-center w-auto gap-3`} >
            {getNavs1()}
            {getLng()}
          </div>
        </div>
      </div>
    );
  }

  const getHome = () => {
    return <>
      <div className={`flex px-0 py-0 w-[4rem] h-[3.125rem]`}>
        <img className={"focus:outline-none cursor-pointer"}
          src={images.logo}
          onClick={() => navigate(ERoute.Home.valueOf())}
        >
        </img>
      </div>
    </>
  }

  const getLng = () => {
    const lngKey = AppLanguageService.getKeyById(AppLanguageService.currentId)
    const v = t(lngKey?lngKey:"")
    return <>
      <div 
        className="w-[5rem]"
        key={v} >
        {ef.getSelectInput({
          required: false,
          v: v,
          o: AppLanguageService.lngKeys,
          listBGColor: "bg-gray-800",
          fOnInputChange: (lngKey) => {
            AppLanguageService.setLanguageByKey(lngKey)
          },
          fgetBGColorByOption: (value?: string) => { return "bg-gray-800" }
        })}
      </div>
    </>
  }


  const getNavs = () => {
    return <nav className={`${AppCSSService.textHeader} w-full`} >

      <div className={`w-full flex gap-8 ${(props.dsc.medium) ? "flex-col" : "items-center justify-center"}`} >
        <NavLink to={ERoute.Home.valueOf()} onClick={() => props.pnc.setIsOpen(false)} className={({ isActive }) => `${navClasses} ${isActive ? navIsActiveClass : ''}`} > {t(ELng.nav_woh_app.valueOf())} </NavLink>
        <NavLink to={ERoute.AboutUs.valueOf()} onClick={() => props.pnc.setIsOpen(false)} className={({ isActive }) => `${navClasses} ${isActive ? navIsActiveClass : ''}`} > {t(ELng.nav_about_us.valueOf())} </NavLink>
        <NavLink to={ERoute.PrivacyPolicy.valueOf()} onClick={() => props.pnc.setIsOpen(false)} className={({ isActive }) => `${navClasses} ${isActive ? navIsActiveClass : ''}`} > {t(ELng.nav_privacy_policy.valueOf())} </NavLink>
        <NavLink to={ERoute.Service.valueOf()} onClick={() => props.pnc.setIsOpen(false)} className={({ isActive }) => `${navClasses} ${isActive ? navIsActiveClass : ''}`} > {t(ELng.nav_service.valueOf())} </NavLink>
      </div>
    </nav>
  }

  const getNavs1 = () => {
    return <nav className={`${AppCSSService.textHeader} w-full`} >
      <div className={`w-full border-2 rounded-md flex hover:bg-white hover:text-bluec ${(props.dsc.medium) ? "flex-col" : "items-center justify-center"}`} >
        <NavLink to={ERoute.Website.valueOf()} onClick={() => props.pnc.setIsOpen(false)} className={({ isActive }) => `${navClasses} ${isActive ? navIsActiveClass : ''}`} > {t(ELng.nav_woh_site.valueOf())} </NavLink>
      </div>
    </nav>
  }
  //#endregion

  return (
    <div
      className={`whitespace-nowrap z-40 fixed left-0 w-full bg-gray-900 rounded-b-xl h-[5rem]
      ${(props.pnc.isHidden) ? ("top-[-6rem] transition-all duration-1000") : ("top-0 transition-all duration-1000")}`}
    >{(!props.dsc.medium) ? getDefaultGUI() : getSmallGUI()} </div>
  );
};

export default PublicNavbar;
